import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { CUSTOMER_HOME_PATH } from '@/lib/navigation/constants/post-auth-destination-constants';

const TrendySVG = () => (
  <svg className="mb-8 h-64 w-64" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="bg-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4F46E5" />
        <stop offset="100%" stopColor="#6366F1" />
      </linearGradient>
    </defs>
    <rect width="200" height="200" fill="url(#bg-gradient)" />
    <circle cx="160" cy="40" r="20" fill="#34D399" className="animate-pulse" />
    <path
      d="M20 120 L60 80 L100 120 L140 80 L180 120"
      stroke="#F472B6"
      strokeWidth="8"
      fill="none"
      className="animate-dash"
    />
    <rect
      x="40"
      y="140"
      width="120"
      height="40"
      fill="#FBBF24"
      rx="20"
      ry="20"
      className="animate-soft-lift"
    />
  </svg>
);

const DevelopmentPage = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => (prevDots.length >= 3 ? '' : prevDots + '.'));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center bg-background p-4 text-center">
      <style>{`
        @keyframes dash {
          to {
            stroke-dashoffset: 0;
          }
        }
        .animate-dash {
          stroke-dasharray: 300;
          stroke-dashoffset: 300;
          animation: dash 3s linear infinite;
        }
        @keyframes soft-lift {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-6px);
          }
        }
        .animate-soft-lift {
          animation: soft-lift 2.4s ease-out infinite;
        }
      `}</style>
      <TrendySVG />
      <h1 className="mb-4 text-3xl font-semibold text-foreground">404 - Page Not Found</h1>
      <p className="mb-8 text-xl text-foreground/90">
        Oops! This page is still under development
        <span className="inline-block w-8 text-left">{dots}</span>
      </p>
      <p className="mb-8 text-base text-foreground/90">
        We&apos;re working hard to bring you something amazing. Please check back later!
      </p>
      <Button asChild>
        <Link to={CUSTOMER_HOME_PATH}>Go Back Home</Link>
      </Button>
    </div>
  );
};

export default DevelopmentPage;
